import { create } from 'zustand';
import type { DimensionKey, IbhDimensions } from '@hub/bearing-hub/common/dimensions/dimensions';
import { IbhShape } from '@igus/iglidur-bearing-hub-api/src/data-contracts';

export interface IbhDimensionsValuesStore {
  dimensions: { [key in IbhShape]: IbhDimensions };
  setDimension: (shapeKey: string, dimension: IbhDimensions) => void;
  setDimensionsValue: (shapeKey: string, key: DimensionKey, value: number) => void;
  hasDimensionValues: (shapeKey: string) => boolean;
  reset: () => void;
}

const baseDimensions = {
  [IbhShape.S]: {},
  [IbhShape.F]: {},
  [IbhShape.FL]: {},
  [IbhShape.T]: {},
  [IbhShape.C]: {},
  [IbhShape.EC]: {},
  [IbhShape.PR]: {},
} as { [key in IbhShape]: IbhDimensions };

export const useDimensionsStore = create<IbhDimensionsValuesStore>((set, get) => ({
  dimensions: baseDimensions,
  setDimension: (shapeKey: IbhShape, dimension: IbhDimensions) =>
    set(state => {
      let newDimensions = state.dimensions;
      newDimensions = {
        ...newDimensions,
        [shapeKey]: {
          ...newDimensions[shapeKey],
          ...dimension,
        },
      };
      return {
        ...state,
        dimensions: newDimensions,
      };
    }),
  setDimensionsValue: (shapeKey: IbhShape, newDimensionsKey: DimensionKey, value: number) =>
    set(state => {
      let newDimensions = { ...state.dimensions };
      newDimensions = {
        ...newDimensions,
        [shapeKey]: { ...newDimensions[shapeKey], [newDimensionsKey]: value },
      };
      return {
        ...state,
        dimensions: newDimensions,
      };
    }),
  hasDimensionValues: (shapeKey: IbhShape) => Object.keys(get().dimensions[shapeKey] || {}).length > 0,
  reset: () =>
    set(state => ({
      ...state,
      dimensions: baseDimensions,
    })),
}));
